/* eslint-disable react/display-name */
import React, { useState, useEffect,useRef } from 'react'
import { useQuery, gql, useApolloClient } from '@apollo/client'
import { withTranslation } from 'react-i18next'
import CustomLoader from '../components/Loader/CustomLoader'
// core components
import Header from '../components/Headers/Header'
import {getworkerassignedorder } from '../apollo'
import DataTable from 'react-data-table-component'
import { withRouter } from 'react-router-dom';
import {
  Container, Button, useTheme} from '@mui/material'
import { customStyles } from '../utils/ppbbtable'
import useGlobalStyles from '../utils/globalStyles'
import TableHeader from '../components/TableHeader'

const GET_WORDERORDERASSIGN = gql`
${getworkerassignedorder}`


const BillingOrderList = ({ searchResult = [],  ...props }) => {
  const { t } = props;
  const globalClasses = useGlobalStyles()
  const scrollRef = useRef(null);
  const [page, setPage] = useState(1 );
  var [tableData, setTableData] = useState([])
  const [currentPage, setCurrentPage] = useState(page);
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const client = useApolloClient();
  const variables = {
    limit: perPage,
    skip: (page - 1) * perPage,
  };
  const {
    data,
    loading: loadingQuery,
    refetch,
  } = useQuery(GET_WORDERORDERASSIGN, {
    fetchPolicy: 'network-only', variables,
    onCompleted: (data) => {
      if (data && data.getWorkerAssignedOrders) {
        tableData = data.getWorkerAssignedOrders.orders || []
        tableData = data.getWorkerAssignedOrders.orders
        setTableData(tableData)
        setTotalRows(data.getWorkerAssignedOrders.totalCount || 0);

      }
    },
    onError: error => {
      const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
      if (isForbiddenError) {
        localStorage.removeItem('user-native');
        localStorage.removeItem('restaurant_id');
        client.clearStore();
        props.history.push('/auth/login');
      }
    },
  })
  // ✅ Scroll to searched order if present
  useEffect(() => {
    if (searchResult.length > 0 && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [searchResult]);

  useEffect(() => {
    if (data) {
      tableData = data.getWorkerAssignedOrders.orders
      setTableData(tableData)
      setTotalRows(data.getWorkerAssignedOrders.totalCount || 0);
    }
  }, [data]);
  // Update the query variables when the page value changes
  useEffect(() => {
    refetch({
      variables: {
        limit: perPage,
        skip: (page - 1) * perPage,
      },
    });
  }, [page, perPage, refetch]);
  const handlePerRowChange = (newPerPage) => {
    setPerPage(newPerPage)
  }
  // Inside your handlePageChange function, update the local storage
  const handlePageChange = (page) => {
    setPage(page);
    setCurrentPage(page)

  };
 
  const getOrderStatusWord = (statusNumber) => {
    const statusMap = {
      0: "INITIATED",
      1: "CONFIRMED",
      2: "PACKING",
      3: "BILLING",
      4: "READY_FOR_DELIVERY",
      5: "RIDER_ASSIGNED",
      6: "OUT_FOR_DELIVERY",
      7: "DELIVERED",
      8: "CANCELLED",
      9: "FAILED_OUT_OF_STOCK",
      10: "FAILED_INVALID_DELIVERY_ADDRESS",
      11: "FAILED",
    };

    return statusMap[statusNumber] || " N/A";
  };
  const columns = [
    {
      name: "Order ID",
      selector: '_id', // Updated selector

      style: { cursor: 'pointer', minWidth: "300px" },
    },

    {
      name: "Store Name",
      selector: 'localStore', // Assuming you want to display localStore
      cell: (row) => <>{row.localStore.join(', ')}</>, // Assuming localStore is an array
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Order Date",
      selector: 'orderDate', // Updated selector
      cell: (row) => <>{new Date(row.orderDate).toLocaleDateString()}</>, // Show only the date part
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Delivery Date",
      selector: 'deliveryDate', // Updated selector
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Completion Time",
      selector: 'completionTime', // Updated selector
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Items Count",
      selector: 'itemsCount', // Updated selector
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Order Status",
      selector: 'orderStatus', // Updated selector
      cell: (row) => <>{getOrderStatusWord(row.orderStatus)}</>, // Use getOrderStatusWord method
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: "Order Amount",
      selector: 'orderAmount', // Updated selector
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: t('Action'),
      cell: row => <>{actionButtons(row)}</>,
    },
  ];
  const theme = useTheme();
  const actionButtons = row => {
    return (
      <>
        <Button
          size="20px"
          variant="contained"
          sx={{
            color: theme.palette.common.white,
            fontWeight: 'bold',
            backgroundColor: theme.palette.warning.dark,
            padding: 0,
            height: '15px',
            fontSize: '7px',
            '&:hover': {
              border: '2px solid #637BFE',
              color: theme.palette.warning.dark,
              backgroundColor: "white"
            }
          }}
          onClick={e => {
            e.preventDefault()
            localStorage.setItem('OrderData', JSON.stringify(row))
            props.history.push({
              pathname: '/billing_admin/OrderDetails',
              state: { id: row._id }
            })
          }}>
          {t('View Details')}
        </Button>

      </>
    )
  }
    // ✅ Show searched order only if searchResult has data
  const displayedData = searchResult && searchResult.length > 0 ? searchResult : tableData;

  // 🎯 Scroll & highlight search result
  useEffect(() => {
    if (searchResult && searchResult.length > 0 && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [searchResult]);
  return (
    <>
      <Header />
      <Container className={globalClasses.flex} fluid>
        {loadingQuery ? (
          <CustomLoader />
        ) : (
          <div ref={scrollRef}>
            <DataTable
              customStyles={customStyles}
              subHeader={true}
              title={<TableHeader title={t('All Billing Details')} />}
              columns={columns}
              data={displayedData || []}
              progressPending={loadingQuery}
              progressComponent={<CustomLoader />}
              paginationDefaultPage={currentPage}
              pagination={searchResult.length === 0} // hide pagination when search active
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowChange}
              onChangePage={handlePageChange}
            />
          </div>
        )}
      </Container>      
    </>
  )
}

export default withTranslation()(withRouter(BillingOrderList));
